import React from "react";
import Aux from "../../../hoc/Auxilliary";
import { makeStyles } from "@material-ui/core/styles";
import { Typography, Grid, Box } from "@material-ui/core/";
import FormStyle from "./prospective.module.css";
import FormBuilder from "../../FormBuilder";

import FormHeader from "../../FormHeader";

const useStyles = makeStyles({
  TableControl: {
    display: "flex",
    flexDirection: "column",
  },
  formControl: {
    color: "white",
  },
  classConatiner: {
    padding: "1rem 0",
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  classHeaderFont: {
    fontSize: "1.1rem",
    fontWeight: 800,
    flex: 1,
  },
  classContentFont: {
    fontSize: "1rem",
    flex: 1,
  },
  formDesign: {
    width: "98%",
    margin: "0 auto",
  },
});

const Page10 = (props) => {
  const classes = useStyles(props);
  const data = props?.applicationJsonData || [];

  const textFieldChangeHandlerForApplication = (event, key) => {
    const updatedData = {
      ...data,
      [event.target.name]: event.target.value,
    };
    props.setApplicationJsonData(updatedData);
  };

  const handleCheck = (event, eventName) => {
    const updatedData = { ...data };
    updatedData[eventName] = event.target.checked;
    props.setApplicationJsonData(updatedData);
  };

  return (
    <Aux>
      <Grid xs={12}>
        <Grid style={{ padding: "0 2.5rem" }}>
          <Typography component="div" className={FormStyle.formContainer}>
            <FormHeader name="Déclaration" />
            <div className={classes.formDesign}>
              <Grid>
                <Typography component="div" className={classes.classHeaderFont}>
                  Il est important de lire attentivement tous les renseignements
                  relatifs à la demande d’admission.
                </Typography>
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Le fait d’omettre de mentionner des faits pertinents (y
                  compris toutes études dans un établissement d’enseignement
                  postsecondaire) ou de soumettre de faux renseignements ou
                  documents peut entrainer un retrait de l’admission et de
                  l’inscription. Toute omission découverte à une session
                  ultérieure peut entrainer le renvoi de l’USB. Toute
                  inscription à un établissement d’enseignement postsecondaire
                  après avoir soumis cette demande doit être signalée par écrit.
                </Typography>
                <br />
                <Typography component="div" className={classes.classHeaderFont}>
                  Loi sur l’accès à l’information et la protection de la vie
                  privée (LAIPVP)
                </Typography>
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Les renseignements personnels recueillis sous l’autorité de la
                  Loi sur l’Université de Saint-Boniface sont utilisés à des
                  fins d’échange d’information en lien avec l’admission,
                  l’inscription, l’évaluation du parcours scolaire et la
                  communication avec la personne ayant soumis sa candidature.
                  <br />
                  Ces renseignements peuvent être divulgés à d’autres
                  établissements d’enseignement, à des départements
                  gouvernementaux et à des organisations coparrains.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Les renseignements des membres de la population étudiante qui
                  adhèrent à l’Associaton Étudiante de l’Université de
                  Saint-Boniface (AEUSB) peuvent être dévoilés à cette
                  association.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Lors de la remise des diplômes, le nom et l’adresse de la
                  personne étudiante, ainsi que les renseignements qui figurent
                  sur les diplômes et certificats obtenus, seront transférés au
                  Bureau de développement, qui les conservera aux fins des
                  efforts de promotion et de développement de l’Université de
                  Saint-Boniface.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Les noms des récipiendaires de bourses et de diplômes peuvent
                  être rendus publics.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Les renseignements personnels ne seront pas utilisés ni
                  divulgués pour d’autres raisons que celles permises par la Loi
                  sur l’accès à l’information et la protection de la vie privée
                  (LAIPVP). Pour toute question concernant la collecte de tes
                  renseignements personnels, communique avec le Bureau de la
                  protection de la vie privée de l’Université de Saint-Boniface
                  204-237-1818, poste 398 ou{" "}
                  <a href="mailto:laipvp@ustboniface.ca">
                    laipvp@ustboniface.ca
                  </a>
                  .
                </Typography>
                <br />
                <Typography component="div" className={classes.classHeaderFont}>
                  Avis de communication des renseignements personnels à
                  Statistique Canada
                </Typography>
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  La Loi sur la statistique du gouvernement fédéral confère à
                  Statistique Canada le pouvoir légal d’accéder aux
                  renseignements personnels détenus par les établissements
                  d’enseignement. Ces renseignements ne peuvent servir qu’à des
                  fins statistiques et les dispositions sur la confidentialité
                  de la Loi sur la statistique interdisent la communication des
                  renseignements de quelque façon que ce soit qui permettrait
                  l’identification d’un membre de la population étudiante.
                </Typography>
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Pour plus amples renseignements, consulter la page{" "}
                  <a
                    href="https://ustboniface.ca/vie-privee#statcan"
                    target="_blank"
                  >
                    https://ustboniface.ca/vie-privee#statcan
                  </a>
                  .
                </Typography>{" "}
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Les membres de la population étudiante peuvent communiquer
                  avec Statistique Canada par courriel s’ils ont des questions :{" "}
                  <a href="mailto:statcan.PSIS-SIEP.statcan@canada.ca">
                    statcan.PSIS-SIEP.statcan@canada.ca
                  </a>
                  .
                </Typography>{" "}
                <br />
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  J’atteste par la présente que j’ai lu et compris les
                  informations et les directives contenues dans cette demande
                  d’admission et que tous les renseignements qui y sont inscrits
                  sont exacts et complets.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Je reconnais que les frais de traitement de dossier qui
                  accompagnent ce formulaire ne sont pas remboursables et ne
                  seront pas appliqués sur les frais de scolarité.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  J’autorise l’Université de Saint-Boniface à vérifier tout
                  renseignement, tout relevé de notes, tout diplôme et toute
                  lettre de recommandation qui accompagnent cette demande
                  d’admission.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Je reconnais que tout renseignement qui figure sur un document
                  falsifié peut être transféré à l’Association des registraires
                  des universités et collèges du Canada.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  J’autorise mon école ou université à divulguer mon dossier
                  scolaire au besoin afin d’accélérer le traitement de cette
                  demande d’admission.
                </Typography>
                <Typography
                  component="div"
                  className={classes.classContentFont}
                >
                  Je comprends qu’à moins d’avoir obtenu mon consentement écrit,
                  l’Université de Saint-Boniface n’est pas autorisée à divulguer
                  des informations concernant mon dossier d’admission, y compris
                  à la personne qui a préparé ou a déposé la demande d’admission
                  en mon nom.
                </Typography>
              </Grid>
            </div>
            <br />
            <Box component="div" style={{ marginLeft: "1rem" }}>
              <FormBuilder
                formDetails={props.formData}
                value={data}
                handleCheck={handleCheck}
                changed={textFieldChangeHandlerForApplication}
              />
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </Aux>
  );
};

export default Page10;
